import { render, staticRenderFns } from "./FormControlOdpCourseDatesBookings.vue?vue&type=template&id=6bd77965"
import script from "./FormControlOdpCourseDatesBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlOdpCourseDatesBookings.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports